/**
 * Format founder names for contact / message UI.
 * e.g. "Founder: Ada Lovelace, Grace Hopper"
 */
export function formatFounderLine(
  foundersData?: Array<{ name?: string | null }> | null
): string | null {
  if (!Array.isArray(foundersData) || foundersData.length === 0) return null;
  const names = foundersData
    .map(f => (typeof f?.name === 'string' ? f.name.trim() : ''))
    .filter(Boolean);
  if (names.length === 0) return null;
  return `Founder: ${names.join(', ')}`;
}
